import { connect } from 'react-redux';

import ScreeningHelp from './ScreeningHelp.js';

const ConnectedScreeningHelp = connect(
  null,
  null
)(ScreeningHelp);

export default ConnectedScreeningHelp;
